import Accordion from '@/components/Accordion/Accordion';

export default Accordion;
